import { initDetailsAccordion } from 'utils/details-accordion'

const acordeonFeature = () => {
  const $faqContainer = document.querySelector<HTMLElement>('[data-js="faq"]')
  if (!$faqContainer) return

  initDetailsAccordion($faqContainer, '[data-js="faq-item"]')
}

export const initFAQ = () => {
  acordeonFeature()
}
